import React, { useEffect, useState } from "react";
import { Form, Checkbox, Typography, Divider, Input, Button, Radio, Select, Row, Col, Space } from "antd";
import WebstoreItem from "../WebstoreItem";
import { apiCall } from "../../../utils/Api";
import MapLocationPicker from "../MapLocationPicker";
export default function GeneralSection(props) {

    const { changed = false, setChanged = () => { } } = props;
    const [pages, setPages] = useState([]);
    const primary = (window.sitesettings.stores[0]);
    const stores = (primary.is_primary) ? window.sitesettings.stores : [window.sitesettings.stores.find(item => item.is_primary)];
    const getPages = () => {
        apiCall("settings/getCustomPages", {}, (_status, _results) => {
            if (_status) {
                setPages(_results);
            }
        })
    }

    useEffect(getPages, []);


    const drawPages = () => {
        return pages.map((item, index) => {
            return (<Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>)
        })
    }

    const { ws, form } = props;

    return (
        <>

            <div id="general"></div>
            <div style={{ "padding": "10px 30px" }}>
                <Typography.Title level={4}>General</Typography.Title>
                <Divider />


                {(window.sitesettings.is_v3 && <>
                    {/* Terms & Conditions Toggle */}
                    <div id="ws_terms_consent_enabled"></div>
                    <WebstoreItem
                        name="global:ws_terms_consent_enabled"
                        value={(ws["global:ws_terms_consent_enabled"]) ? true : false}
                        heading="Enable Terms & Conditions"
                        description={<div>Enable this to add a mandatory "I agree to the Terms & Conditions" checkbox during new account creation, editing existing account information, account based checkout, quote checkout, and guest checkout. Customers must check that option in order to proceed with creating/editing an account or checking out. "Terms & Conditions" will be a link to the Terms & Conditions Menu. <br /><br />Refer to your local customer data collection and use disclosure laws to ensure your Terms & Conditions page meets those requirements. Date-stamped customer consent records will be saved and available for audit should you require it.</div>}
                    />
                    <Divider dashed />
                </>)}



                {(window.sitesettings.is_v3 && <>
                    {/* Terms & Conditions Toggle */}
                    <div id="ws_privacy_policy_url"></div>
                    <Space>
                        <div style={{ "width": "35px" }}></div>
                        <div>
                            <Typography.Title level={5}>Privacy Policy URL</Typography.Title>
                            <Typography.Paragraph type="secondary">The full URL link for your privacy policy page. This link will be shown during checkout for texting and optionally in your footer. If you have created a page through the webstore designer, please copy and paste the link from your customer site for that page.</Typography.Paragraph>
                            <Form.Item name="global:ws_privacy_policy_url" initialValue={ws["global:ws_privacy_policy_url"] || ""}>
                               <Input placeholder="Privacy policy url..." />
                            </Form.Item>
                        </div>
                    </Space>
                    <Divider dashed />
                </>)}


                {(!window.sitesettings.is_v3 && <>
                    <div id="ws_policy_page"></div>
                    {/* Terms & Conditions Page */}
                    <Space>
                        <div style={{ "width": "35px" }}></div>
                        <div>
                            <Typography.Title level={5}>Privacy Policy Page</Typography.Title>
                            <Typography.Paragraph type="secondary">If you have a Privacy Policy page, you can link to it in your page footer here.</Typography.Paragraph>
                            <Form.Item name="global:ws_policy_page" initialValue={ws["global:ws_policy_page"]}>
                                <Select dropdownMatchSelectWidth={false} >
                                    <Select.Option key="" value="">- Use standard page -</Select.Option>
                                    {drawPages()}
                                </Select>
                            </Form.Item>
                        </div>
                    </Space>
                    <Divider dashed />
                </>)}

                {(!window.sitesettings.is_v3 && <>

                    <div id="ws_custom_contact_page"></div>
                    {/* Contact Us Page */}
                    <Space>
                        <div style={{ "width": "35px" }}></div>
                        <div>
                            <Typography.Title level={5}>Contact Us Page</Typography.Title>
                            <Typography.Paragraph type="secondary">Choose whether to use the standard Contact Us page, or one of your custom pages.</Typography.Paragraph>
                            <Form.Item name="global:ws_custom_contact_page" initialValue={ws["global:ws_custom_contact_page"]}>
                                <Select dropdownMatchSelectWidth={false}>
                                    <Select.Option key="" value="">- Use standard page -</Select.Option>
                                    {drawPages()}
                                </Select>
                            </Form.Item>
                        </div>
                    </Space>
                    <Divider dashed />
                </>)}


                <div id="ws_hide_footer_address"></div>
                {/* Street address In footer: ws_hide_footer_address */}
                <Space>
                    <div style={{ "width": "35px" }}></div>
                    <div>
                        <Typography.Title level={5}>Street address In footer:</Typography.Title>
                        <Form.Item initialValue={(ws["global:ws_hide_footer_address"]) ? true : false} noStyle name="global:ws_hide_footer_address">
                            <Radio.Group>
                                <Radio value={false}>Show</Radio>
                                <div className="shim"></div>
                                <Radio value={true}>Hide</Radio>
                                <div className="shim"></div>
                            </Radio.Group>
                        </Form.Item>
                        <Typography.Paragraph type="secondary">You may wish to hide the street address if you have multiple store locations.</Typography.Paragraph>
                    </div>
                </Space>

                <Divider dashed />
                <div id="ws_facebookurl"></div>
                {/* Social media */}
                <Space>
                    <div style={{ "width": "35px" }}></div>
                    <div>
                        {/* Social media */}
                        <Typography.Title level={5}>Social media</Typography.Title>
                        <Typography.Paragraph type="secondary">If you have any social media pages for your store you may enter the relative information in the boxes and an icon/link will appear down below in the footer of your Webstore.</Typography.Paragraph>
                        {/* <Form layout="vertical"> */}
                        <label>Facebook URL</label>
                        <Form.Item rules={[{ type: "url", message: "Must be a valid url." }]} name="global:ws_facebookurl" initialValue={ws["global:ws_facebookurl"]} label="">
                            <Input style={{ "maxWidth": "500px" }} placeholder="https://facebook.com/" />
                        </Form.Item>
                        <label>X (Twitter) Id</label>
                        <Form.Item help={<small className="c">Max 20 characters</small>} name="global:ws_twitter_username" initialValue={ws["global:ws_twitter_username"]} label="">
                            <Input maxLength={20} style={{ "maxWidth": "500px" }} placeholder="Twitter id" />
                        </Form.Item>
                        <label>Instagram Id</label>
                        <Form.Item help={<small className="c">Max 30 characters</small>} name="global:ws_instagram_username" initialValue={ws["global:ws_instagram_username"]} label="">
                            <Input maxLength={30} style={{ "maxWidth": "500px" }} placeholder="Instagram id" />
                        </Form.Item>
                        <label>Tiktok URL</label>
                        <Form.Item rules={[{ type: "url", message: "Must be a valid url." }]} name="global:ws_tiktok_url" initialValue={ws["global:ws_tiktok_url"]} label="">
                            <Input style={{ "maxWidth": "500px" }} placeholder="https://tiktok.com/" />
                        </Form.Item>

                        <label>Threads URL</label>
                        <Form.Item rules={[{ type: "url", message: "Must be a valid url." }]} name="global:ws_threads_url" initialValue={ws["global:ws_threads_url"]} label="">
                            <Input style={{ "maxWidth": "500px" }} placeholder="https://www.threads.net/username" />
                        </Form.Item>

                        <label>Bluesky URL</label>
                        <Form.Item rules={[{ type: "url", message: "Must be a valid url." }]} name="global:ws_bluesky_url" initialValue={ws["global:ws_bluesky_url"]} label="">
                            <Input style={{ "maxWidth": "500px" }} placeholder="https://username.bsky.app/" />
                        </Form.Item>

                        <label>Mastodon URL</label>
                        <Form.Item rules={[{ type: "url", message: "Must be a valid url." }]} name="global:ws_mastodon_url" initialValue={ws["global:ws_mastodon_url"]} label="">
                            <Input style={{ "maxWidth": "500px" }} placeholder="https://mstdn.social/username" />
                        </Form.Item>
                        {/* </Form> */}
                    </div>
                </Space>

                <div id="ws_social_media_facebook_shareable"></div>
                <Divider dashed />
                <Space>
                    <div style={{ "width": "35px" }}></div>
                    <div>
                        <Typography.Title level={5}>Event sharing control</Typography.Title>
                        <Typography.Paragraph type="secondary">Determine on behalf of your customers which social media platforms are authorized for sharing events. </Typography.Paragraph>
                        <Space direction="vertical" >
                            <Form.Item valuePropName='checked' initialValue={(ws["global:ws_social_media_facebook_shareable"]) ? true : false} name="global:ws_social_media_facebook_shareable" noStyle>
                                <Checkbox>Facebook</Checkbox>
                            </Form.Item>
                            <Form.Item valuePropName='checked' initialValue={(ws["global:ws_social_media_twitter_shareable"]) ? true : false} name="global:ws_social_media_twitter_shareable" noStyle>
                                <Checkbox>X (Twitter)</Checkbox>
                            </Form.Item>
                            <Form.Item valuePropName='checked' initialValue={(ws["global:ws_social_media_bluesky_shareable"]) ? true : false} name="global:ws_social_media_bluesky_shareable" noStyle>
                                <Checkbox>Bluesky</Checkbox>
                            </Form.Item>
                            <Form.Item valuePropName='checked' initialValue={(ws["global:ws_social_media_mastodon_shareable"]) ? true : false} name="global:ws_social_media_mastodon_shareable" noStyle>
                                <Checkbox>Mastodon</Checkbox>
                            </Form.Item>
                            <Form.Item valuePropName='checked' initialValue={(ws["global:ws_social_media_threads_shareable"]) ? true : false} name="global:ws_social_media_threads_shareable" noStyle>
                                <Checkbox>Threads</Checkbox>
                            </Form.Item>
                        </Space>
                    </div>
                </Space>

                <Divider dashed />
                <div id="ws_libro_bookstore_name"></div>
                {/* Libro.fm Audiobook Integration */}
                <Space>
                    <div style={{ "width": "35px" }}></div>
                    <div>
                        <Typography.Title level={5}>Libro.fm Audiobook Integration</Typography.Title>
                        <Typography.Paragraph type="secondary">If you have registered as an audiobook retailer with Libro.fm, you can allow customers browsing your webstore the option to purchase Libro.fm audiobooks when they are available for a title. Audiobook purchases will be completed on the Libro.fm website, but your store will earn commision based on those sales.</Typography.Paragraph>
                        <Typography.Paragraph type="secondary">Enter your store's Libro.fm Storefront URL name in the field below to enable the integration.</Typography.Paragraph>
                        <Typography.Paragraph type="secondary"><strong>NOTE:</strong> Do not type your bookstore's full name in this field. Your Libro.fm <strong>Storefront URL</strong> name is what is required. For example, Mosaic Books' Libro.fm Storefront URL is https://libro.fm/mosaicbooks, so the Storefront URL name is the last bit, <strong>mosaicbooks</strong> (all one word). This URL can be found by logging into your Libro.fm account, clicking the Gear icon near the Bookseller Hub menu item at the top, then by clicking the Store Info link from the left menu.</Typography.Paragraph>
                        <Form.Item name="global:ws_libro_bookstore_name" initialValue={ws["global:ws_libro_bookstore_name"]} noStyle>
                            <Input maxLength={30} style={{ "maxWidth": "500px" }} placeholder="Libro.fm store name" />
                        </Form.Item>
                    </div>
                </Space>

                <Divider dashed />
                {/* Show libro FM link on details screen. */}
                <div id="ws_prominent_librofm"></div>
                <WebstoreItem
                    name="global:ws_prominent_librofm"
                    value={(ws["global:ws_prominent_librofm"]) ? true : false}
                    heading="Show Libro.fm Buy Audiobook button on title details page."
                    description={<div>Enabling will show the Libro.fm buy audiobook link on the details screen for titles. Otherwise, the Libro.fm audiobook link will be displayed with the title's bindings/other editions when an audiobook version is available.</div>}
                />

                <Divider dashed />

                <div id="ws_bookshop_affiliate_id"></div>
                {/* Bookshop.org Ebook Integration */}
                <Space>
                    <div style={{ "width": "35px" }}></div>
                    <div>
                        <Typography.Title level={5}>Bookshop.org Ebook Integration (USA stores only)</Typography.Title>
                        <Typography.Paragraph type="secondary">
                            If you have registered as an ebook and/or physical book retailer with Bookshop.org, you can allow customers browsing your webstore the option to purchase Bookshop.org ebooks when they are available for a title. Ebook purchases will be completed on the Bookshop.org website, but your store will earn commission based on those sales.
                        </Typography.Paragraph>
                        <Typography.Paragraph type="secondary">
                            Enter your store's Bookshop.org <strong>Affiliate ID</strong> in the field below to enable the integration. If the field is greyed out, please contact Bookmanager support to enable the Bookshop.org integration, or to renew your subscription for this feature.                        </Typography.Paragraph>
                        <Form.Item
                            name="global:ws_bookshop_affiliate_id"
                            initialValue={ws["global:ws_bookshop_affiliate_id"]}
                            rules={[
                                {
                                    pattern: /^\d+$/,
                                    message: "Affiliate ID must be an integer."
                                }
                            ]}
                        >
                            <Input maxLength={30} disabled={!ws["global:ws_bookshop_subscription"]} style={{ "maxWidth": "500px" }} placeholder="Bookshop.org Affiliate ID" />
                        </Form.Item>
                    </div>
                </Space>

                <Divider dashed />
                {/* Show Bookshop.org link on details screen. */}
                <div id="ws_bookshop_prominent"></div>
                <WebstoreItem
                    name="global:ws_bookshop_prominent"
                    value={(ws["global:ws_bookshop_prominent"]) ? true : false}
                    disabled={!ws["global:ws_bookshop_subscription"]}
                    heading="Show Bookshop.org Buy ebook button on title details page."
                    description={<div>Enabling will show the Bookshop.org buy ebook link on the details screen for titles. Otherwise, the Bookshop.org ebook link will be displayed with the title's bindings/other editions when an ebook version is available.</div>}
                />

                <Divider dashed />
                {/* Treat non-approved customers as anonymous users */}
                <div id="ws_display_carton_quantity"></div>
                <WebstoreItem
                    name="global:ws_display_carton_quantity"
                    value={(ws["global:ws_display_carton_quantity"]) ? true : false}
                    heading="Display carton quantity below Add to Cart"
                    description={<div>By default, if a title has a carton quantity from the publisher, that will be displayed under the title's Details tab. Enable this option if you would like to feature the carton quantity more predominantly, within the Add to Cart area.</div>}
                />

                {/* <Divider dashed /> */}
                {/* Open titles in new Bookmanager */}
                {/* <div id="bm_use_biz_url"></div>
                <WebstoreItem
                    name="global:bm_use_biz_url"
                    value={(ws["global:bm_use_biz_url"]) ? true : false}
                    heading="View on Webstore sends to Biz"
                    description={<div>Enabling will display titles on the new Biz website when pressing <code>W</code> in Bookmanager. Disabled, pressing <code>W</code> will load the old admin website.</div>}
                /> */}

                <Divider dashed />
                <div style={{ "opacity": (window.sitesettings.is_canadian) ? "1" : "0.2", "pointerEvents": (window.sitesettings.is_canadian) ? "inherit" : "none" }}>
                    {/* Display Government of Canada funding acknowledgement */}
                    <div id="ws_government_of_canada_logo_enabled"></div>
                    <WebstoreItem
                        name="global:ws_government_of_canada_logo_enabled"
                        value={(ws["global:ws_government_of_canada_logo_enabled"]) ? true : false}
                        heading="Display Government of Canada funding acknowledgement"
                        description={<div>Displays a small acknowledgement with the Government of Canada logo in your consumer site's footer.
                            <br /><div className="shim" />
                            <Typography.Text>
                                <Form.Item valuePropName='checked' initialValue={(ws["global:ws_government_of_canada_bilingual"]) ? true : false} name="global:ws_government_of_canada_bilingual" noStyle>
                                    <Checkbox />
                                </Form.Item> Display Bilingual?</Typography.Text>

                        </div>}
                    />
                </div>


                <Divider dashed />
                <div id="ws_libro_bookstore_name"></div>
                {/* Libro.fm Audiobook Integration */}
                <Space>
                    <div style={{ "width": "35px" }}></div>
                    <div>
                        <Typography.Title level={5}>Store location marker</Typography.Title>
                        <Typography.Paragraph type="secondary">To display the store location marker, we use the address data provided for your store. Occasionally, this location data may be inaccurate or imprecise. Use the adjust button to fine-tune the marker's placement.</Typography.Paragraph>

                        {stores.map((item, index) => {
                            let _name = "ms" + item.store_number + ":ws_google_maps_override";
                            return (
                                <>
                                    <MapLocationPicker changed={changed} setChanged={setChanged} label={item.altname} form={form} value={ws[_name]} name={_name} />
                                </>
                            )
                        })}

                    </div>
                </Space>

            </div>
        </>
    )
}